import React from 'react';
import {
    Dialog, DialogContent, Typography, Button, Divider, Grid, IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';

const styles = {
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 24px 12px',
    },
    headerTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    content: {
        padding: '16px 24px 24px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 8,
        padding: '12px 24px 16px',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 500,
        padding: '8px 24px',
    },
};

function ConfirmActionDialog({
    open,
    onClose,
    onConfirm,
    title,
    message,
    description,
    children,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    confirmColor = '#f44336',
    confirmVariant = 'contained',
    confirmDisabled = false,
    icon = null,
    iconColor = '#ff9800',
    loading = false,
}) {
    const IconComponent = icon || WarningIcon;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: { borderRadius: 12, overflow: 'hidden' }
            }}
        >
            {/* Header */}
            <div style={styles.header}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <IconComponent style={{ fontSize: 28, color: iconColor, marginRight: 12 }} />
                    <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>
                        {title}
                    </Typography>
                </div>
                <IconButton size="small" onClick={onClose} style={{ color: '#9e9e9e' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>

            <Divider />

            {/* Content */}
            <DialogContent style={styles.content}>
                {message && (
                    <Typography variant="body1" style={{ marginBottom: description ? 12 : 0, color: '#424242', lineHeight: 1.6 }}>
                        {message}
                    </Typography>
                )}
                {description && (
                    <Typography variant="body2" style={{ color: '#757575', lineHeight: 1.5 }}>
                        {description}
                    </Typography>
                )}
                {children && <div style={{ marginTop: 16 }}>{children}</div>}
            </DialogContent>

            {/* Footer */}
            <div style={styles.footer}>
                <Button
                    onClick={onClose}
                    style={styles.cancelBtn}
                    disabled={loading}
                >
                    {cancelLabel}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant={confirmVariant}
                    disabled={loading || confirmDisabled}
                    style={{
                        backgroundColor: confirmVariant === 'contained' ? confirmColor : 'transparent',
                        color: confirmVariant === 'contained' ? '#fff' : confirmColor,
                        textTransform: 'none',
                        fontWeight: 600,
                        padding: '8px 28px',
                        borderRadius: 6,
                        boxShadow: confirmVariant === 'contained' ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
                    }}
                >
                    {loading ? 'Processando...' : confirmLabel}
                </Button>
            </div>
        </Dialog>
    );
}

export default ConfirmActionDialog;
